import React from 'react'
import { Reply } from './ElementsStyled'
import { BETREPLY_ELEMENTS_PROPS } from './interface'
export default function BetId({
  content,
  majorTextColor,
  minorTextColor,
  textAreaColor,
}: BETREPLY_ELEMENTS_PROPS) {
  return (
    <Reply
      majorTextColor={majorTextColor}
      minorTextColor={minorTextColor}
      textAreaColor={textAreaColor}
    >
      <h3>{content.title}</h3>
      <p>{content.content}</p>
    </Reply>
  )
}
